module.exports = __webpack_public_path__ + "img/DE00897.03ec72e7.png";